<div class="upload-card mb-3">
  <h5 class="form-title"> {{ title() | translate }}</h5>
  <div
    class="upload-box"
    (click)="uploadBoxClicked()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
    [class.dragover]="isDragOver">

    <input #fileInput type="file" [multiple]="!singleFileUpload()" (click)="clearAllFiles()" (change)="onFilesSelected($event)" class="file-input d-none" [accept]="acceptFileType()" />
    <div class="upload-content">
      @if (!fileName || !singleFileUpload()) {
        <mat-icon class="upload-text large-icon">cloud_upload</mat-icon>
        <p class="upload-text">{{ 'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.FOOTER' | translate }}</p>
        <p class="upload-limit">{{ 'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.MAX_SIZE' | translate }}</p>
        <p class="upload-limit">{{ acceptFileTypeLabel }}</p>
      }
      @if (fileName && singleFileUpload()) {
        <mat-icon svgIcon="custom-document" class="document-icon"></mat-icon>
        <h4 class="py-2">{{fileName}}</h4>
        <div class="row mb-0 py-2 search-input-row justify-content-end btn-grps-p-24">
          <div class="col-auto">
            <tpa-button (click)="clear($event)" [config]="clearButtonConfig"></tpa-button>
          </div>
          <div class="col-auto">
            <tpa-button (click)="upload($event)" [config]="uploadButtonConfig"></tpa-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="row mb-3">
  @for (uploadedFile of uploadedFiles; track $index; let i = $index) {
    <div class="mt-3" [ngClass]="isDialog() ? 'col-12' : 'col-md-6 col-lg-4 col-12'">
      <div class="single-file d-flex align-items-center border rounded p-2 shadow-sm">
        <div class="file-icon me-2">
          <mat-icon svgIcon="custom-document"></mat-icon>
        </div>
        <div class="info flex-grow-1" [matTooltip]="uploadedFile.file['name']" matTooltipClass="custom-tooltip">
          <h4 class="name mt-1">{{ uploadedFile.file['name'] }}</h4>
          <p class="size mt-1">.{{ uploadedFile.file['ext'] }} · {{ 'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.SIZE' | translate }} {{ formatBytes(uploadedFile.file['fileSize'] || uploadedFile.file.size) }}</p>
        </div>
        <div class="view" (click)="preview(uploadedFile)" [matTooltip]="'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.CLICK_FOR_VIEW' | translate" matTooltipClass="custom-tooltip">
          <mat-icon>visibility</mat-icon>
        </div>
        <div class="download" (click)="downloadAttachments(uploadedFile)" [matTooltip]="'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.CLICK_FOR_DOWNLOAD' | translate" matTooltipClass="custom-tooltip">
          <mat-icon>cloud_download</mat-icon>
        </div>
        @if (!uploadedFile.isNotDeletable) {
          <div class="delete" (click)="removeFile(i)" [matTooltip]="'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.CLICK_FOR_DELETE' | translate" matTooltipClass="custom-tooltip">
            <mat-icon>close</mat-icon>
          </div>
        }
      </div>
    </div>
  }
</div>
